import { StyleSheet, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

export const cardStyle = StyleSheet.create({
    normalCard: {
        margin: isWeb ? 8 : 4,
        borderRadius: isWeb ? 12 : 8,
        shadowColor: '#000',
        shadowOffset: isWeb ? { width: 0, height: 2 } : { width: 0, height: 1 },
        shadowOpacity: isWeb ? 0.08 : 0.05,
        shadowRadius: isWeb ? 8 : 4,
        elevation: isWeb ? 3 : 2,
    },
    bluetoothCard: {
        margin: isWeb ? 8 : 4,
        borderColor: 'gray',
        borderRadius: isWeb ? 12 : 8,
        elevation: 2,
        borderWidth: 1,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 6,
      }
})